import _slicedToArray from '@babel/runtime-corejs3/helpers/esm/slicedToArray';
import _Promise from '@babel/runtime-corejs3/core-js-stable/promise';

var isElementVisible = function isElementVisible(element) {
  var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.99;
  if (!element || !(element instanceof HTMLElement)) return _Promise.resolve(false);
  return new _Promise(function (resolve) {
    var observer = new IntersectionObserver(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        entry = _ref2[0];
      resolve(entry.isIntersecting);
      observer.disconnect();
    }, {
      threshold: [threshold]
    });
    observer.observe(element);
  });
};

export { isElementVisible };
//# sourceMappingURL=useIsElementVisible.js.map
